import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";
import { _3_DAYS } from "../../../constants/durations";

async function fetchTopicList(showArchived: boolean, spaceId: string) {
  let query = apiClient
    .from('topics')
    .select()
    .eq('space_id', spaceId)
    .order('name', { ascending: true });

    if (!showArchived) {
      query = query.is('archived', false);
    }

    const { data, error } = await query;

  if (error) {
    throw error;
  }

  return data;
}

export function useGetTopicList(showArchived: boolean) {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.topicListArchivedOrNot(showArchived),
    queryFn: () => fetchTopicList(showArchived, currentSpace!.id),
    enabled: !!currentSpace?.id,
    staleTime: _3_DAYS
  })
}
